import get from 'lodash/get';
import { GET_CLEARING_REQUEST_FULFILLED, GET_CLEARING_REQUEST_REJECTED, POST_CLEARING_REQUEST_CONFIRM_FULFILLED, POST_CLEARING_REQUEST_CONFIRM_REJECTED, RESET_CLEARING_REQUEST, } from 'constants/ActionTypes';
const clearingRequestReducer = (state = null, action) => {
    switch (action.type) {
        case GET_CLEARING_REQUEST_FULFILLED: {
            return action.payload.data;
        }
        case GET_CLEARING_REQUEST_REJECTED: {
            return state || { failed: true, status: get(action, 'payload.status') };
        }
        case POST_CLEARING_REQUEST_CONFIRM_FULFILLED: {
            return Object.assign(Object.assign({}, state), { confirmed: true });
        }
        case POST_CLEARING_REQUEST_CONFIRM_REJECTED: {
            return get(action, 'payload.status') === 409 ? Object.assign(Object.assign({}, state), { confirmed: true }) : state;
        }
        case RESET_CLEARING_REQUEST: {
            return null;
        }
        default:
            return state;
    }
};
export default clearingRequestReducer;
